import { active, content_inner, detail_wrapper, heading, link } from 'Styles/modules/content-page.module.scss';

import Container from 'Components/Container';
import Link from 'next/link';
import classNames from 'classnames';
import { useRouter } from 'next/router';

const ContentDetail = props => {
  const { className, content: {title, content} } = props;
  const router = useRouter()

  return (
    <aside className={classNames(detail_wrapper, className)}>
      <h1 className={classNames(heading, 'hidden lg:block')}>{title}</h1>
      <article className={content_inner} dangerouslySetInnerHTML={{__html: content}} />
    </aside>
  );
};

export default ContentDetail;
